import React from "react";
import "./PreviewProjects.css";
import { useNavigate, NavLink } from "react-router-dom";
import useGetHomepageInfo from "../../hooks/useGetHomepageInfo";

// Maps an award label to its badge style class and medal icon.
const awardMeta = (award) => {
  switch ((award || "").toLowerCase()) {
    case "1st place":
      return { cls: "award-1st", icon: "🥇" };
    case "2nd place":
      return { cls: "award-2nd", icon: "🥈" };
    case "3rd place":
      return { cls: "award-3rd", icon: "🥉" };
    case "discovery":
      return { cls: "award-discovery", icon: "🔭" };
    case "seeds":
      return { cls: "award-seeds", icon: "🌱" };
    default:
      return { cls: "award-default", icon: "★" };
  }
};

const PreviewProjects = () => {
  const navigate = useNavigate();
  const { homepageInfo } = useGetHomepageInfo();

  const previewData = homepageInfo?.previews || [];

  return (
    <div className="section-container">
      <h1 className="preview-header font-light">Explore Inspiring Projects</h1>
      <div className="preview-projects-list">
        {previewData?.slice(0, 8).map((project, index) => {
          const meta = awardMeta(project.award);
          return (
            <div
              key={index}
              className={`project-row ${meta.cls}`}
              onClick={() => navigate(`/projects/${project._id}`)}
            >
              {project.previewImage && (
                <img
                  className="row-img"
                  src={project.previewImage.asset.url}
                  alt={project.previewImage.alt || "Project Image"}
                />
              )}
              <div className="row-content">
                {project.award && (
                  <span className={`award-badge ${meta.cls}`}>
                    <span className="award-icon">{meta.icon}</span>
                    {project.award}
                  </span>
                )}
                <h2 className="row-title line-clamp-2">{project.title}</h2>
                <p className="row-summary line-clamp-2">
                  {project.projectSummary}
                </p>
              </div>
            </div>
          );
        })}
      </div>
      <div className="button-container">
        <NavLink to="/projects">
          <button>MORE PROJECTS</button>
        </NavLink>
      </div>
    </div>
  );
};

export default PreviewProjects;
